import { Injector } from '@angular/core';

let appInjector: Injector;


export function setAppInjector(injector: Injector) {
    if (!appInjector) {
        appInjector = injector;
    }
}

export function getAppInjector(): Injector {
    return appInjector;
}
